import { env } from '@/constant/env';
import { getAuthToken } from '@/utils/localStorage';

export type MediaEndpoint = { url: string; getToken: () => string | null };

let current: MediaEndpoint = {
  url: env.VITE_MEDIA_API_URL,
  getToken: getAuthToken
};

export const setMediaEndpoint = (endpoint: MediaEndpoint): void => {
  current = endpoint;
};

export const getMediaEndpoint = (): MediaEndpoint => current;
